import React from 'react';

const variantStyles = {
  primary:
    'bg-am-accent text-white hover:bg-am-accent-700 shadow-md hover:-translate-y-0.5 transition transform',
  secondary:
    'border border-gray-200 text-am-text-900 hover:bg-gray-50',
  ghost:
    'text-am-text-900 hover:bg-gray-100',
};

const sizeStyles = {
  sm: 'px-4 py-1 text-sm rounded-md',
  md: 'px-5 py-2.5 rounded-md',
  lg: 'px-6 py-3 text-base rounded-md',
};

/**
 * Button reusable.
 * @param {string} variant - 'primary' | 'secondary' | 'ghost'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {boolean} fullWidth - lebar penuh
 * @param {string} className - class tambahan
 * @param {React.ReactNode} children
 * @param {object} rest - props lain (onClick, disabled, type, href jika as="a", dll)
 */
function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  as: Component = 'button',
  ...rest
}) {
  const base = 'inline-flex items-center justify-center font-semibold focus:outline-none focus:ring-2 focus:ring-am-accent focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variantClass = variantStyles[variant] || variantStyles.primary;
  const sizeClass = sizeStyles[size] || sizeStyles.md;
  const widthClass = fullWidth ? 'w-full' : '';

  const combined = [base, variantClass, sizeClass, widthClass, className].filter(Boolean).join(' ');

  return <Component className={combined} {...rest}>{children}</Component>;
}

export default Button;
